import { graphql } from "babel-plugin-relay/macro";
import { useCallback, useContext } from "react";
import { useMutation } from "react-relay";
import {
  useRefreshShopifyTokenMutation$data,
  useRefreshShopifyTokenMutation as useRefreshShopifyTokenMutationType,
} from "./__generated__/useRefreshShopifyTokenMutation.graphql";
import SnackbarContext from "../contexts/SnackbarContext";

const mutation = graphql`
  mutation useRefreshShopifyTokenMutation($brandId: ID!) {
    refreshShopifyToken(brandId: $brandId) {
      state
      accessTokenLast4
      accessTokenExpiresAt
      refreshTokenExpiresAt
      refreshedAt
      error
      adminChangeUrl
    }
  }
`;

const useRefreshShopifyTokenMutation = (): [
  (
    brandId: string,
    onCompleted?: (data: useRefreshShopifyTokenMutation$data) => void
  ) => void,
  boolean
] => {
  const [commitMutation, isMutationInFlight] =
    useMutation<useRefreshShopifyTokenMutationType>(mutation);
  const snackbarContext = useContext(SnackbarContext);

  const onMutate = useCallback(
    (
      brandId: string,
      onCompleted?: (data: useRefreshShopifyTokenMutation$data) => void
    ) => {
      commitMutation({
        variables: { brandId },
        onCompleted: (data, errors) => {
          if (errors) {
            snackbarContext?.openSnackbar(
              "Could not refresh the Shopify token",
              "error"
            );
          } else {
            onCompleted && onCompleted(data);
            snackbarContext?.openSnackbar("Shopify token refreshed", "success");
          }
        },
        onError: () => {
          snackbarContext?.openSnackbar(
            "Could not refresh the Shopify token",
            "error"
          );
        },
      });
    },
    [commitMutation, snackbarContext]
  );

  return [onMutate, isMutationInFlight];
};

export default useRefreshShopifyTokenMutation;
